import {Component, EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {ReplaySubject} from 'rxjs';
import {Ofwca} from '../../../shared/interface/ofwca';
import {MatDialogRef} from '@angular/material/dialog';
import {FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import {MatSnackBar} from '@angular/material/snack-bar';
import {Router} from '@angular/router';
import {FormHelperService} from '../../../shared/services/form-helper.service';
import {
  COMPANY_ASF,
  COMPANY_ASF_PREMIUM,
  CONTRACT_STATUS_ACTIVE,
  CONTRACT_STATUS_DURING_TERMINATION,
  CONTRACT_STATUS_TO_TERMINATE,
  CONTRACT_TYPE_FRANCHISE,
  CONTRACT_TYPE_PARTNERSHIP,
  CONTRACT_TYPE_PROFIT,
  DICT_TYPE_DOUBLE_REGISTRATION,
  DICT_TYPE_KRK_PAYER,
  DICT_TYPE_WHAT_IS_NEEDED,
  DictService,
  DOUBLE_REGISTRATION_NONE,
  DYNAMIC_DICTIONARY_COMPENSA_OFFICE, DYNAMIC_DICTIONARY_COMPENSA_OFFICE_PROFIT,
  DYNAMIC_DICTIONARY_MANAGER_WIENER,
  KRK_PAYER_ASF,
  KRK_PAYER_PARTNER,
  REGISTRATION_WHAT_IS_NEEDED_EXAM_AND_REGISTRATION,
  SALES_COMPENSA,
  SALES_COMPENSA_WIENER,
  WHAT_IS_NEEDED_RE_REGISTRATION,
  WHAT_IS_NEEDED_REGISTRATION
} from '../../../shared/services/dict.service';
import {delay, filter, first, takeUntil} from 'rxjs/operators';
import {Uuid} from '../../../shared/interface/response/uuid';
import {HttpErrorResponse} from '@angular/common/http';
import {RegistrationAddDialogComponent} from '../registration-add-dialog/registration-add-dialog.component';
import {RegistrationService} from '../../../shared/services/registration.service';
import {Contract} from '../../../shared/interface/contract';
import {OfwcaRegistrationInfo} from '../../../shared/interface/ofwca-registration-info';
import {InsuranceCompany} from '../../../shared/interface/insurance-company';
import {Dictionary} from '../../../shared/interface/dictionary';
import {FileInput, FileValidator} from 'ngx-material-file-input';
import {validNip} from '../../../shared/validator/nip-validator';
import {
  IC_COMPENSA, IC_COMPENSA_LIFE,
  IC_EUROP_ASSISTANCE,
  IC_EUROPA,
  IC_LINK4,
  IC_PZU, IC_PZU_LIFE, IC_TRASTI,
  IC_WIENER
} from '../../../shared/services/insurance-company.service';
import {PhoneNumber} from "../../../shared/interface/phone-number";
import {EmailAddress} from "../../../shared/interface/email-address";
import {OfwcaService} from "../../../shared/services/ofwca.service";
import {ContractService} from "../../../shared/services/contract.service";
import {validPhoneNumber} from "../../../shared/validator/phone-validator";
import {JobResultDialogComponent} from "../../../shared/components/job-result-dialog/job-result-dialog.component";

@Component({
  selector: 'app-registration-add',
  templateUrl: './registration-add.component.html',
  styleUrls: ['./registration-add.component.scss']
})
export class RegistrationAddComponent implements OnInit, OnDestroy {
  @Input() ofwcaObject?: Ofwca;
  @Input() contractObject?: Contract;
  @Input() dialogRef?: MatDialogRef<RegistrationAddDialogComponent>;
  @Output() closeModification = new EventEmitter<any>();
  @Output() registrationCreated = new EventEmitter<string>();

  readonly COMPANY_ASF = COMPANY_ASF;
  readonly CONTRACT_TYPE_PROFIT = CONTRACT_TYPE_PROFIT;
  readonly IC_PZU = IC_PZU;
  readonly CHRONIE_INSURANCE_COMPANIES = [
    IC_WIENER,
    IC_EUROPA
  ];
  readonly  DYNAMIC_DICTIONARY_MANAGER_WIENER = DYNAMIC_DICTIONARY_MANAGER_WIENER;
  readonly DYNAMIC_DICTIONARY_COMPENSA_OFFICE = DYNAMIC_DICTIONARY_COMPENSA_OFFICE;
  readonly DYNAMIC_DICTIONARY_COMPENSA_OFFICE_PROFIT = DYNAMIC_DICTIONARY_COMPENSA_OFFICE_PROFIT;

  registrationForm: FormGroup;
  ofwcaControl: FormControl;
  contractControl: FormControl;
  insuranceCompanyControl: FormControl;
  whatIsNeededControl: FormControl;
  doubleRegistrationControl: FormControl;
  salesProfilesControl: FormControl;
  diplomaFileControl: FormControl;
  exam100pFileControl: FormControl;
  exam100pInsuranceCompanyControl: FormControl;
  exam40pFileControl: FormControl;
  registrationCompensaOfficeNewControl: FormControl;
  registrationCompensaLifeOfficeControl: FormControl;
  chronieLoginControl: FormControl;
  registrationFacilityAddressGroup: FormGroup;
  registrationFacilityAddressPzuGroup: FormGroup;
  selectedContract?: Contract;
  selectedInsuranceCompany?: InsuranceCompany;
  contractCompanyId: ReplaySubject<number> = new ReplaySubject<number>(1);
  showAllContracts = false;
  ofwcaRegistrationInfo?: OfwcaRegistrationInfo;
  ofwcaContracts: ReplaySubject<Contract[]> = new ReplaySubject<Contract[]>(1);
  ofwcaContractsPom: [];
  processingRequest = false;
  errors: any = {};
  availableSalesProfiles = false;
  requireExam40p = false;
  optionalExam40p = false;
  requireExam100p = false;
  requireDiploma = false;
  requireExam100pInsuranceCompany = false;
  missingExam100p = false;
  registrationFormValid = false;
  salesProfilesDictTypeSubject: ReplaySubject<string> = new ReplaySubject<string>(1);
  fileMaxSize = 5242880;
  requireLink4Data = false;
  requirePzuData = false;
  // requireTrasti = false;
  requirePzuLife = false;
  selectedOfwca?: Ofwca;
  requireCompensaData = false;
  requireCompensaLifeData = false;

  private destroyed$: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);

  constructor(
    private registrationService: RegistrationService,
    private snackBar: MatSnackBar,
    private router: Router,
    private fb: FormBuilder,
    private formHelper: FormHelperService,
    private dictService: DictService,
    private ofwcaService: OfwcaService,
    private contractService: ContractService,
  ) {
    this.registrationForm = this.fb.group({
      ofwca: this.ofwcaControl = fb.control('', [Validators.required]),
      contract: this.contractControl = fb.control('', [Validators.required]),
      showAllContracts: fb.control(false),
      insuranceCompany: this.insuranceCompanyControl = fb.control('', [Validators.required]),
      whatIsNeeded: this.whatIsNeededControl = fb.control('', [Validators.required]),
      doubleRegistration: this.doubleRegistrationControl = fb.control('', [Validators.required]),
      salesProfiles: this.salesProfilesControl = fb.control([], [Validators.required]),
      diploma: this.diplomaFileControl = fb.control('', [FileValidator.maxContentSize(this.fileMaxSize)]),
      diplomaContent: fb.control(''),
      diplomaFilename: fb.control(''),
      exam100p: this.exam100pFileControl = fb.control('', [FileValidator.maxContentSize(this.fileMaxSize)]),
      exam100pContent: fb.control(''),
      exam100pFilename: fb.control(''),
      exam100pInsuranceCompany: this.exam100pInsuranceCompanyControl = fb.control(''),
      exam40p: this.exam40pFileControl = fb.control('', [FileValidator.maxContentSize(this.fileMaxSize)]),
      exam40pContent: fb.control(''),
      exam40pFilename: fb.control(''),
      registrationNip: fb.control('', [validNip(), Validators.required]),
      registrationFacilityAddress: this.registrationFacilityAddressGroup = this.formHelper.generateAddressFormGroup(),
      registrationOfwcaOwner: fb.control('', [Validators.required]),
      registrationCompanyName: fb.control('', [Validators.required]),
      registrationPartnerEmail: fb.control('', [Validators.required, Validators.email]),
      note: fb.control(''),
      registrationCompensaOfficeNew: this.registrationCompensaOfficeNewControl = fb.control('', [Validators.required]),
      chronieLogin: this.chronieLoginControl = fb.control('', [Validators.email, Validators.required]),
      registrationAgencyName: fb.control('', [Validators.required]),
      registrationFacilityAddressPzu: this.registrationFacilityAddressPzuGroup = this.formHelper.generateAddressFormGroup(true,true ,true),
      // trastiEmail:  fb.control('', [Validators.email, Validators.required]),
      registrationCompensaLifeOffice: this.registrationCompensaLifeOfficeControl = fb.control('', [Validators.required]),
      additionalEmail: fb.control('', [Validators.email]),
      additionalPhone: fb.control('', [validPhoneNumber()]),
    });

    this.chronieLoginControl.disable();
  }

  ngOnInit(): void {
    this.registrationForm.valueChanges
      .pipe(
        delay(0),
        takeUntil(this.destroyed$)
      )
      .subscribe(() => this.registrationFormValid = this.registrationForm.valid);

    this.registrationForm.get('showAllContracts').valueChanges
      .pipe(takeUntil(this.destroyed$))
      .subscribe((val: boolean) => this.showAllContracts = val);

    this.ofwcaControl.valueChanges
      .pipe(takeUntil(this.destroyed$))
      .subscribe((ofwcaId: string) => {
        this.registrationService.getOfwcaRegistrationInfo(ofwcaId)
          .subscribe((ofwcaRegistrationInfo: OfwcaRegistrationInfo) => {
            const availableContracts = ofwcaRegistrationInfo.contracts.filter((contract: Contract) =>
              ![CONTRACT_TYPE_FRANCHISE].includes(contract.type?.key) );
            if (!this.contractObject) {
              this.ofwcaContracts.next(availableContracts);

              let activeContract = null;
              let activeAsfPremiumContract = null;
              let asfPremiumContract = null;
              ofwcaRegistrationInfo.contracts.forEach((contract: Contract) => {
                if (contract.company?.key === COMPANY_ASF_PREMIUM) {
                  asfPremiumContract = contract;

                  if (contract.status?.key === CONTRACT_STATUS_ACTIVE) {
                    activeAsfPremiumContract = contract;
                  }
                }

                if (contract.status?.key === CONTRACT_STATUS_ACTIVE) {
                  activeContract = contract;
                }
              });

              if (null !== activeAsfPremiumContract) {
                this.contractControl.setValue(activeAsfPremiumContract.uuid);
                this.contractChanged(activeAsfPremiumContract);
              } else if (null !== activeContract) {
                this.contractControl.setValue(activeContract.uuid);
                this.contractChanged(activeContract);
              } else if (null !== asfPremiumContract) {
                this.contractControl.setValue(asfPremiumContract.uuid);
                this.contractChanged(asfPremiumContract);
              }
            }

            this.ofwcaRegistrationInfo = ofwcaRegistrationInfo;

            if (!ofwcaRegistrationInfo.diplomaAttached) {
              this.diplomaFileControl.enable();
            } else {
              this.diplomaFileControl.disable();
            }
          });
      });



    this.contractControl.valueChanges
      .pipe(takeUntil(this.destroyed$))
      .subscribe(() => {
        this.insuranceCompanyControl.reset();
        this.insuranceCompanyControl.setValue(null);
      });

    this.diplomaFileControl.valueChanges
      .pipe(
        takeUntil(this.destroyed$),
        filter((file?: FileInput) => !!file)
      )
      .subscribe((file: FileInput) => {
        this.registrationForm.get('diplomaFilename').setValue(file.fileNames);
        this.registrationForm.get('diplomaContent').reset('');

        file.files.forEach((fileToRead: File) => {
          const reader = new FileReader();
          reader.readAsDataURL(fileToRead);
          reader.onload = () => {
            this.registrationForm.get('diplomaContent').setValue(
              this.registrationForm.get('diplomaContent').value +
              (this.registrationForm.get('diplomaContent').value ? ', ' : '') +
              (/base64,(.+)/.exec(reader.result.toString())[1])
            );
          };
        });
      });

    this.exam100pFileControl.valueChanges
      .pipe(
        takeUntil(this.destroyed$),
        filter((file?: FileInput) => !!file)
      )
      .subscribe((file: FileInput) => {
        this.registrationForm.get('exam100pFilename').setValue(file.fileNames);
        this.registrationForm.get('exam100pContent').reset('');

        file.files.forEach((fileToRead: File) => {
          const reader = new FileReader();
          reader.readAsDataURL(fileToRead);
          reader.onload = () => {
            this.registrationForm.get('exam100pContent').setValue(
              this.registrationForm.get('exam100pContent').value +
              (this.registrationForm.get('exam100pContent').value ? ', ' : '') +
              (/base64,(.+)/.exec(reader.result.toString())[1])
            );
          };
        });

        this.requireExam100pInsuranceCompany = true;
        this.exam100pInsuranceCompanyControl.setValidators([Validators.required]);
      });

    this.exam40pFileControl.valueChanges
      .pipe(
        takeUntil(this.destroyed$),
        filter((file?: FileInput) => !!file)
      )
      .subscribe((file: FileInput) => {
        this.registrationForm.get('exam40pFilename').setValue(file.fileNames);
        this.registrationForm.get('exam40pContent').reset('');

        file.files.forEach((fileToRead: File) => {
          const reader = new FileReader();
          reader.readAsDataURL(fileToRead);
          reader.onload = () => {
            this.registrationForm.get('exam40pContent').setValue(
              this.registrationForm.get('exam40pContent').value +
              (this.registrationForm.get('exam40pContent').value ? ', ' : '') +
              (/base64,(.+)/.exec(reader.result.toString())[1])
            );
          };
        });
      });

    if (this.contractObject) {
      this.contractControl.setValue(this.contractObject.uuid);
      this.contractChanged(this.contractObject);
    }

    if (this.ofwcaObject) {
      this.ofwcaControl.setValue(this.ofwcaObject.uuid);
      this.ofwcaChanged(this.ofwcaObject);
    }

    this.dictService.getId(DOUBLE_REGISTRATION_NONE, DICT_TYPE_DOUBLE_REGISTRATION)
      .subscribe((dictId: number) => this.doubleRegistrationControl.setValue(dictId));

    this.dictService.getId(REGISTRATION_WHAT_IS_NEEDED_EXAM_AND_REGISTRATION, DICT_TYPE_WHAT_IS_NEEDED)
      .subscribe((dictId: number) => this.whatIsNeededControl.setValue(dictId));
  }

  ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }

  whatIsNeededChanged(dict: Dictionary): void {
    if (dict.key === WHAT_IS_NEEDED_REGISTRATION) {
      this.diplomaFileControl.setValidators([FileValidator.maxContentSize(this.fileMaxSize), Validators.required]);
      this.exam40pFileControl.setValidators([FileValidator.maxContentSize(this.fileMaxSize), Validators.required]);
      this.exam100pFileControl.setValidators([FileValidator.maxContentSize(this.fileMaxSize), Validators.required]);
      this.exam100pInsuranceCompanyControl.setValidators([Validators.required]);
      this.requireDiploma = true;
      this.requireExam40p = true;
      this.requireExam100p = true;
    } else {
      this.requireExam100p = false;
      this.requireExam40p = false;
      this.requireDiploma = false;
      if (!this.requireExam100pInsuranceCompany) {
        this.exam100pInsuranceCompanyControl.setValidators([]);
      }
      this.diplomaFileControl.setValidators([FileValidator.maxContentSize(this.fileMaxSize)]);
      this.exam40pFileControl.setValidators([FileValidator.maxContentSize(this.fileMaxSize)]);
      this.exam100pFileControl.setValidators([FileValidator.maxContentSize(this.fileMaxSize)]);

      this.diplomaFileControl.reset();
      this.exam40pFileControl.reset();
      this.exam100pFileControl.reset();
    }

    this.optionalExam40p = dict.key === WHAT_IS_NEEDED_RE_REGISTRATION;
  }

  contractChanged(contract: Contract): void {
    this.contractCompanyId.next(contract.company.id);
    this.selectedContract = contract;
  }

  ofwcaChanged(ofwca: Ofwca): void {
    this.selectedOfwca = ofwca;
    this.updateChronieForm();
  }

  save(resetForm = false): void {
    if (  this.registrationForm.get('insuranceCompany').value.key === IC_PZU)
      {
        this.formHelper.setAddress( this.registrationForm.get('registrationFacilityAddressPzu').value,
          this.registrationFacilityAddressGroup);
      }
    this.processingRequest = true;
    this.registrationService.sendForm(this.registrationForm.getRawValue())
      .pipe(
        first()
      )
      .subscribe((response: Uuid) => {
        this.snackBar.open('Pomyślnie utworzono rejestrację', '', {
          duration: 2000,
        });
        this.processingRequest = false;

        if (resetForm) {
          const formValue = this.registrationForm.value;
          this.registrationForm.reset({
            ofwca: formValue.ofwca,
            showAllContracts: formValue.showAllContracts,
            contract: formValue.contract,
            whatIsNeeded: formValue.whatIsNeeded,
            doubleRegistration: formValue.doubleRegistration,
            salesProfiles: [],
          });
          this.requireLink4Data = false;
          this.requirePzuData = false;

          return;
        }

        if (this.dialogRef) {
          this.registrationCreated.emit();
          this.dialogRef.close();
        } else {
          this.router.navigate(['/rejestracje/szczegoly', response.uuid]);
        }
      }, (error: HttpErrorResponse) => {
        this.processingRequest = false;

        if (error.error.error.list.insuranceCompany) {
          this.snackBar.open(' '
            + error.error.error.list.insuranceCompany.toString() , error.status.toString(), {
            duration: 8000,
            panelClass: ['success-snackbar']
          });
        } else {
          this.snackBar.open( 'Podczas przesyłania formularza wystąpił błąd', error.status.toString(), {
            duration: 2000,
          });
        }

        if (error.status === 400) {
          this.errors = error.error.error.list;
          this.formHelper.setBackendErrorState(this.registrationForm, this.errors);
        }
      });
  }

  cancel(): void {
    if (this.dialogRef) {
      this.dialogRef.close();
    } else {
      this.router.navigate(['/rejestracje']);
    }
  }

  insuranceCompanyChanged(insuranceCompany: InsuranceCompany): void {
    this.availableSalesProfiles = false;

    this.dictService.getDictSubject()
      .pipe(first())
      .subscribe((items: Dictionary[]) => {
        items.forEach((dict: Dictionary) => {
          if (dict.type === 'sales_' + insuranceCompany.key) {
            this.availableSalesProfiles = true;
          }
        });
      });

    this.selectedInsuranceCompany = insuranceCompany;

    if (this.availableSalesProfiles) {
      this.registrationForm.get('salesProfiles').enable();
      this.salesProfilesDictTypeSubject.next('sales_' + insuranceCompany.key);
    } else {
      this.registrationForm.get('salesProfiles').disable();
    }

    if (insuranceCompany && insuranceCompany.key === IC_COMPENSA) {
      this.requireCompensaData = true;
      this.registrationCompensaOfficeNewControl.enable();
    } else {
      this.requireCompensaData = false;
      this.registrationCompensaOfficeNewControl.disable();
    }

    if (insuranceCompany && insuranceCompany.key === IC_COMPENSA_LIFE) {
      this.requireCompensaLifeData = true;
      this.registrationCompensaLifeOfficeControl.enable();
    } else {
      this.requireCompensaLifeData = false;
      this.registrationCompensaLifeOfficeControl.disable();
    }

    if (insuranceCompany && insuranceCompany.key === IC_LINK4) {
      this.requireLink4Data = true;
      this.requirePzuData = false;
      // this.requireTrasti = false;
      this.requirePzuLife = false;
      this.registrationForm.get('registrationNip').enable();
      this.registrationForm.get('registrationOfwcaOwner').enable();
      this.registrationForm.get('registrationCompanyName').enable();
      this.registrationForm.get('registrationPartnerEmail').enable();
      this.registrationForm.get('additionalEmail').enable();
      this.registrationForm.get('additionalPhone').enable();
      this.registrationForm.get('registrationFacilityAddress').enable();
      this.registrationForm.get('registrationFacilityAddressPzu').disable();
      // this.registrationForm.get('trastiEmail').disable();
      this.registrationForm.get('registrationAgencyName').disable();
      this.registrationForm.get('registrationNip').setValue(this.selectedOfwca?.partner?.nip);
      this.registrationForm.get('registrationOfwcaOwner').setValue(this.selectedContract?.partner?.owner?.fullName);
      this.registrationForm.get('registrationCompanyName').setValue(this.selectedContract?.partner?.fullName);
      this.registrationForm.get('registrationPartnerEmail').setValue(this.selectedContract?.partner?.primaryEmails[0]?.address);
      if (this.selectedOfwca?.facility?.address){
        this.formHelper.setAddress(this.selectedOfwca.facility.address, this.registrationFacilityAddressGroup);
      }
    } else if (insuranceCompany && insuranceCompany.key === IC_PZU) {
      this.requireLink4Data = false;
      this.requirePzuData = true;
      // this.requireTrasti = false;
      this.requirePzuLife = false;
      this.registrationForm.get('registrationNip').enable();
      this.registrationForm.get('registrationAgencyName').enable();
      this.registrationForm.get('additionalEmail').enable();
      this.registrationForm.get('additionalPhone').enable();
      this.registrationForm.get('registrationFacilityAddress').disable();
      this.registrationForm.get('registrationFacilityAddressPzu').enable();
      // this.registrationForm.get('trastiEmail').disable();
      this.registrationForm.get('registrationOfwcaOwner').disable();
      this.registrationForm.get('registrationCompanyName').disable();
      this.registrationForm.get('registrationPartnerEmail').disable();

    } else if (insuranceCompany && insuranceCompany.key === IC_TRASTI) {
      this.requireLink4Data = false;
      this.requirePzuData = false;
      // this.requireTrasti = true;
      this.requirePzuLife = false;
      this.registrationForm.get('registrationNip').disable();
      this.registrationForm.get('registrationOfwcaOwner').disable();
      this.registrationForm.get('registrationCompanyName').disable();
      this.registrationForm.get('registrationPartnerEmail').disable();
      this.registrationForm.get('registrationFacilityAddress').disable();
      this.registrationForm.get('registrationFacilityAddressPzu').disable();
      this.registrationForm.get('additionalEmail').disable();
      this.registrationForm.get('additionalPhone').disable();
      // this.registrationForm.get('trastiEmail').enable();
      this.registrationForm.get('registrationAgencyName').disable();
      this.registrationForm.get('registrationNip').setValue('');
      this.registrationForm.get('registrationOfwcaOwner').setValue('');
      this.registrationForm.get('registrationCompanyName').setValue('');
      this.registrationForm.get('registrationPartnerEmail').setValue('');
      // this.registrationForm.get('trastiEmail').setValue(this?.selectedOfwca?.email);


    } else if (insuranceCompany && insuranceCompany.key === IC_PZU_LIFE) {
      this.requireLink4Data = false;
      this.requirePzuData = false;
      // this.requireTrasti = false;
      this.requirePzuLife = true;
      this.registrationForm.get('registrationNip').enable();
      this.registrationForm.get('registrationOfwcaOwner').disable();
      this.registrationForm.get('registrationCompanyName').disable();
      this.registrationForm.get('registrationPartnerEmail').disable();
      this.registrationForm.get('registrationFacilityAddress').disable();
      this.registrationForm.get('registrationFacilityAddressPzu').enable();
      this.registrationForm.get('additionalEmail').enable();
      this.registrationForm.get('additionalPhone').enable();
      // this.registrationForm.get('trastiEmail').disable();
      this.registrationForm.get('registrationAgencyName').enable();
      // this.registrationForm.get('registrationNip').setValue('');
      this.registrationForm.get('registrationOfwcaOwner').setValue('');
      this.registrationForm.get('registrationCompanyName').setValue('');
      this.registrationForm.get('registrationPartnerEmail').setValue('');


    } else  {
      this.requireLink4Data = false;
      this.requirePzuData = false;
      // this.requireTrasti = false;
      this.requirePzuLife = false;
      this.registrationForm.get('registrationNip').disable();
      this.registrationForm.get('registrationOfwcaOwner').disable();
      this.registrationForm.get('registrationCompanyName').disable();
      this.registrationForm.get('registrationPartnerEmail').disable();
      this.registrationForm.get('registrationFacilityAddress').disable();
      this.registrationForm.get('registrationFacilityAddressPzu').disable();
      this.registrationForm.get('additionalEmail').disable();
      this.registrationForm.get('additionalPhone').disable();
      // this.registrationForm.get('trastiEmail').disable();
      this.registrationForm.get('registrationAgencyName').disable();
      this.registrationForm.get('registrationNip').setValue('');
      this.registrationForm.get('registrationOfwcaOwner').setValue('');
      this.registrationForm.get('registrationCompanyName').setValue('');
      this.registrationForm.get('registrationPartnerEmail').setValue('');
    }

    if (!this.ofwcaRegistrationInfo.passedExam100pAssets && !this.ofwcaRegistrationInfo.passedExam100pLife) {
      this.missingExam100p = true;
      this.exam100pFileControl.enable();
    } else {
      this.missingExam100p = false;
      this.exam100pFileControl.disable();
    }

    this.updateChronieForm();
  }

  updateChronieForm(): void {
    if (
      [IC_WIENER, IC_EUROPA, IC_EUROP_ASSISTANCE].includes(this.selectedInsuranceCompany?.key)
      && !this.selectedOfwca?.chronieLogin
    ) {
      // this.chronieLoginControl.enable();
      //
      // if (!this.chronieLoginControl.value) {
      //   this.chronieLoginControl.setValue(this?.selectedOfwca?.email);
      // }
    } else {
      this.chronieLoginControl.disable();
    }
  }

  downloadPartner(): void{
    if (!this.ofwcaObject) {
      this.ofwcaService.get(this.ofwcaControl.value)
        .subscribe((ofwca: Ofwca) => {
          if (ofwca.facility) {
            this.formHelper.setPzuAddress(ofwca.facility.address, this.registrationFacilityAddressPzuGroup);
          }
        });
    }else {
      if (this.ofwcaObject.facility) {
        this.formHelper.setPzuAddress(this.ofwcaObject.facility.address, this.registrationFacilityAddressPzuGroup);
      }
    }

      this.contractService.get(this.contractControl.value).subscribe((contract: Contract) => {
        this.registrationForm.get('registrationNip').setValue(contract?.partner?.nip);
        this.registrationForm.get('registrationAgencyName').setValue(contract?.partner?.fullName);
      });

  }

}
